import React, { Component } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/pagination';


export class Brands extends Component {


    constructor() {
        super()
        this.state = {
            brandimages: []
        }
    }


    async componentDidMount() {
        await fetch(`${process.env.REACT_APP_MY_API_URL}/wp-json/wp/v2/pages/18`).then((response) => {
            response.json().then((res) => {
                this.setState({
                    brandimages: [res.acf.expertise_image_1, res.acf.expertise_image_2, res.acf.expertise_image_3, res.acf.expertise_image_4, res.acf.expertise_image_5, res.acf.expertise_image_6, res.acf.expertise_image_7]
                })
            })

        })
    }
    render() {
        return (

            <div className="section techwix-brand-section techwix-brand-section-03 section-padding section-padding-05">
                <div className="container">
                    {/* <!-- Brand Wrapper Start --> */}
                    <div className="brand-wrapper text-center">
                        {
                            this.state.brandimages ?
                                <div className="brand-active">
                                    <div className="swiper-container">
                                        <Swiper className="swiper-wrapper"
                                        slidesPerView={4}
                                        spaceBetween={30}                                        
                                        loop={true}
                                        autoplay={{
                                            delay:1000
                                        }}                                            
                                        modules={[Pagination, Autoplay]} 
                                        breakpoints={{
                                            0: {
                                                slidesPerView: 1
                                            },
                                            576: {
                                                slidesPerView: 1
                                            },
                                            768: {
                                                slidesPerView: 1
                                            },
                                            992: {
                                                slidesPerView: 3
                                            },
                                            1200: {
                                                slidesPerView: 4
                                            }
                                        }}
                                        >
                                            {
                                                this.state.brandimages.map((item, i) =>
                                                    item!==false?
                                                    <SwiperSlide key={i} className="swiper-slide single-brand">
                                                        <img src={item.toString()} alt="Brand" style={{maxWidth:"100%", height:"auto", maxHeight:"45px", filter: "grayscale(100%)" }} />
                                                    </SwiperSlide>
                                                    :''
                                                )
                                            }
                                        </Swiper>
                                    </div>
                                </div>


                                : null
                        }

                    </div>
                    {/* <!-- Brand Wrapper End --> */}
                </div>
            </div >
        )
    }
}

export default Brands